import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "currencyCode", "price", "dataSelenium", "round"];
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import styled from 'styled-components';
import { useCustomCurrencyUnit } from '../../../hooks/useCustomCurrencyUnit';
import { jsx as _jsx } from "react/jsx-runtime";
const Span = styled.span.withConfig({
  displayName: "PriceDisplay__Span",
  componentId: "sc-7huqpg-0"
})(["font-weight:", ";"], props => props.weight);
const PriceDisplay = _ref => {
  let {
      className,
      currencyCode,
      price,
      dataSelenium = '',
      round = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Span, Object.assign({
    className: className,
    "data-selenium-id": dataSelenium
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedCurrency, {
      simplifyCurrency: true,
      value: round ? Math.ceil(price) : price,
      currencyCode: currencyCode,
      unit: useCustomCurrencyUnit(currencyCode)
    })
  }));
};
const _CrossedOutPriceDisplay = styled(PriceDisplay).withConfig({
  displayName: "PriceDisplay___CrossedOutPriceDisplay",
  componentId: "sc-7huqpg-1"
})(["text-decoration:line-through;"]);
export const CrossedOutPriceDisplay = props => {
  return /*#__PURE__*/_jsx(_CrossedOutPriceDisplay, Object.assign({}, props));
};
export default PriceDisplay;